import type { IncomeType, IncomeStatus } from "./types";

export const INCOME_TYPE_LABELS: Record<IncomeType, { ru: string; en: string; kk: string }> = {
  deposit_interest: {
    ru: "Вознаграждение по депозитам",
    en: "Deposit Interest",
    kk: "Депозиттер бойынша сыйақы",
  },
  grant: {
    ru: "Гранты международных доноров",
    en: "International Donor Grants",
    kk: "Халықаралық донорлардың гранттары",
  },
  entrance_fee: {
    ru: "Вступительные взносы",
    en: "Entrance Fees",
    kk: "Кіру жарналары",
  },
  membership_fee: {
    ru: "Членские взносы",
    en: "Membership Fees",
    kk: "Мүшелік жарналар",
  },
  charity: {
    ru: "Благотворительная помощь",
    en: "Charitable Aid",
    kk: "Қайырымдылық көмек",
  },
  sponsorship: {
    ru: "Спонсорская помощь",
    en: "Sponsorship",
    kk: "Демеушілік көмек",
  },
  gratuitous: {
    ru: "Безвозмездно полученное имущество",
    en: "Gratuitous Property",
    kk: "Тегін алынған мүлік",
  },
  government_social_order: {
    ru: "Доходы по гос. социальному заказу",
    en: "Government Social Order Income",
    kk: "Мемлекеттік әлеуметтік тапсырыс бойынша табыстар",
  },
  donation: {
    ru: "Пожертвования физических лиц",
    en: "Individual Donations",
    kk: "Жеке тұлғалардың қайырмалдықтары",
  },
  rental: {
    ru: "Доход от аренды имущества",
    en: "Rental Income",
    kk: "Мүлікті жалға беруден түскен табыс",
  },
  other: {
    ru: "Прочие доходы",
    en: "Other Income",
    kk: "Басқа табыстар",
  },
};

export const INCOME_STATUS_ORDER: Record<IncomeStatus, number> = {
  draft: 0,
  confirmed: 1,
  reversed: 2,
};
